var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('n3-popover', {
    ref: "popover",
    attrs: {
      "effect": _vm.effect,
      "header": false,
      "placement": _vm.placement,
      "trigger": "click"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "10px"
    }
  }, [_c('n3-button', {
    attrs: {
      "size": "sm"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$refs.popover.isShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('n3-button', {
    attrs: {
      "size": "sm",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirm($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.okText))])], 1)]), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d10df830", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d10df830"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Popover/n3PopConfirm.vue
// module id = 657
// module chunks = 0 1